
import { areaRoleReducer } from "../reducer/AreaRoleReducer";

export const reducer = areaRoleReducer;